<template>
  <!--右侧树形展示所有停车场-->
  <div class="trees">
    <el-input
      class="search"
      placeholder="输入关键字"
      v-model="filterText"
    ></el-input>
    <el-tree
      ref="tree"
      :data="allDatas"
      :props="defaultProps"
      @node-click="handleTreeClick"
      node-key="id"
      :highlight-current="true"
      :show-checkbox="false"
      :expand-on-click-node="true"
      :default-expanded-keys="expandedKeys"
      :filter-node-method="filterNode"
      @node-expand="handleNodeExpand"
    >
      <span slot-scope="{ node, data }" class="group">
        <span v-if="data.type === 'parking-group'">
          <span class="group-name" style="color: #e6a23c; font-weight: bold">{{
            node.label
          }}</span>
        </span>
        <span
          v-else-if="
            data.type === 'parking-class1' || data.type === 'parking-class2'
          "
        >
          <span class="group-name" style="color: #409eff; font-weight: bold">{{
            node.label
          }}</span>
        </span>
        <span v-else>
          <span class="group-name" v-if="data.type == 'admin'">{{
            node.label
          }}</span>
          <span class="group-name" v-if="data.type == 'group'">
            <span class="group-name-tip">集团</span>
            {{ node.label }}
          </span>
          <span class="group-name" v-if="data.type == 'property'">
            <span class="group-name-tip">物业</span>
            {{ node.label }}
          </span>
          <span class="group-name" v-if="data.type == 'parking'">
            <span class="group-name-tip">车场</span>
            {{ node.label }}
          </span>
          <span class="group-name" v-if="data.type == 'shops'">
            <span class="group-name-tip">商户</span>
            {{ node.label }}
          </span>
        </span>
      </span>
    </el-tree>
  </div>
</template>
<script>
import { getShareParkTree } from "@/api/url";
import { mapState, mapMutations, mapGetters } from "vuex";
export default {
  data() {
    return {
      allDatas: [],
      showArea: false,
      showBox: false,
      showChannel: false,
      nodeKeys: [],
      expandedKeys: [],
      defaultProps: {
        children: "children",
        label: "name",
      },
      filterText: "",
      dialogFormVisible: false,
      delDialogFormVisible: false,
      form: {
        id: "",
        type: "",
        parentId: "",
        name: "",
        person: "",
        phone: "",
      },
      delForm: {
        id: "",
        password: "",
      },
    };
  },
  props: {
    moduleName: String,
    areaId: String,
    shareType: String, //共享类型 personal:个人, company:企业,ordinary:普通,share:共享,all:全部
  },
  methods: {
    ...mapMutations(["getPage"]),
    getAllDatas: function () {
      var _this = this;
      this.$get(getShareParkTree(), {}).then((data) => {
        // 优化：parking 分组
        if (this.moduleName == "parking") {
          let temp = this.getDataByType("parking", data[0], this.shareType);
          console.log("获取树形数据", temp);
          this.allDatas = Array.isArray(temp) ? temp : temp ? [temp] : [];
        } else {
          this.allDatas = data?.[0]?.children ?? [];
        }
        // 清空之前的节点keys
        this.expandedKeys = [];
        // 递归获取第一个节点的所有子节点ID
        if (this.allDatas && this.allDatas.length > 0) {
          this.getAllNodeIds(this.allDatas);
          // 保存展开状态
          sessionStorage.setItem(
            "shareExpandedNodes",
            JSON.stringify(this.expandedKeys)
          );
        }
        // 保存数据到session
        sessionStorage.setItem("shareTreeData", JSON.stringify(this.allDatas));
      });
    },
    // 递归获取所有子节点ID
    getAllNodeIds(node) {
      if (!node) return;

      // 添加当前节点ID
      this.expandedKeys.push(node.id);

      // 递归处理所有子节点
      if (node.children && node.children.length > 0) {
        node.children.forEach((child) => {
          this.getAllNodeIds(child);
        });
      }
    },
    //点击树的节点展示相应数据
    handleTreeClick: function (data, node) {
      this.getPage({
        curIndex: 1,
        rowsCount: 0,
      });

      // 保存当前选中的节点
      sessionStorage.setItem(
        "shareSelectedNode",
        JSON.stringify({
          id: data.id,
          type: data.type,
          name: data.name,
        })
      );

      // 保存当前展开的节点
      sessionStorage.setItem(
        "shareExpandedNodes",
        JSON.stringify(this.expandedKeys)
      );

      this.$emit("handleTreeClick", data);
    },

    // 新增：处理节点展开事件
    handleNodeExpand(data) {
      // 清空之前的节点keys
      this.expandedKeys = [];
      // 确保不重复添加
      if (!this.expandedKeys.includes(data.id)) {
        this.expandedKeys.push(data.id);
      }
    },
    setCurrent(id) {
      this.$refs.tree.setCurrentKey(id);
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    getDataByType(type, data, shareType) {
      // 基础数据提取函数
      const extractBaseData = (node) => ({
        type: node.type,
        name: node.name,
        contact: node.contact,
        mobile: node.mobile,
        id: node.id,
        parentId: node.parentId,
        address: node.address,
        attr2: node.attr2,
      });

      if (!data) return null;

      // 收集所有parking节点（含自身）
      const collectParkingNodes = (node) => {
        let result = [];
        if (node.type === 'parking' && (node.attr2 == 1 || node.attr2 == 2)) {
          result.push(extractBaseData(node));
        }
        if (Array.isArray(node.children)) {
          node.children.forEach(child => {
            result = result.concat(collectParkingNodes(child));
          });
        }
        return result;
      };

      // 按shareType分组parking节点
      const groupParkingByShareType = (allParking, shareType) => {
        const group1 = allParking.filter(item => item.attr2 == 2); // 一类车场
        const group2 = allParking.filter(item => item.attr2 == 1); // 二类车场
        const groupChildren = [];
        if (shareType === 'personal') {
          if (group1.length > 0) {
            groupChildren.push({
              type: 'parking-class1',
              name: '一类车场',
              children: group1,
            });
          }
        } else if (shareType === 'company') {
          if (group2.length > 0) {
            groupChildren.push({
              type: 'parking-class2',
              name: '二类车场',
              children: group2,
            });
          }
        } else if (shareType === 'share') {
          if (group1.length > 0) {
            groupChildren.push({
              type: 'parking-class1',
              name: '一类车场',
              children: group1,
            });
          }
          if (group2.length > 0) {
            groupChildren.push({
              type: 'parking-class2',
              name: '二类车场',
              children: group2,
            });
          }
        }
        return groupChildren;
      };

      // 根节点为parking时，直接分组
      if (data.type === 'parking') {
        const allParking = collectParkingNodes(data);
        return groupParkingByShareType(allParking, shareType);
      }

      // property节点根据shareType分组
      if (data.type === 'property') {
        const allParking = collectParkingNodes(data);
        return {
          ...extractBaseData(data),
          children: groupParkingByShareType(allParking, shareType)
        };
      }

      // 其它类型递归
      if (!Array.isArray(data.children) || data.children.length === 0) {
        return null;
      }
      const children = data.children
        .map((child) => this.getDataByType(type, child, shareType))
        .filter(Boolean);
      if (children.length === 0) {
        return null;
      }
      return {
        ...extractBaseData(data),
        children,
      };
    },
    permiss() {
      this.property_btn_add = this.elements["property:btn_add"];
      this.property_btn_edit = this.elements["property:btn_edit"];
      this.property_btn_remove = this.elements["property:btn_remove"];
      this.grouplist_btn_add = this.elements["grouplist:btn_add"];
      this.grouplist_btn_edit = this.elements["grouplist:btn_edit"];
      this.grouplist_btn_remove = this.elements["grouplist:btn_remove"];
    },
  },
  created() {
    this.permiss();
  },
  mounted() {
    this.permiss();
    // 尝试从session恢复数据
    // const savedTreeData = sessionStorage.getItem("shareTreeData");
    // if (savedTreeData) {
    //   this.allDatas = [...JSON.parse(savedTreeData)];
    //   // 恢复展开状态
    //   const savedExpandedNodes = sessionStorage.getItem("shareExpandedNodes");
    //   if (savedExpandedNodes) {
    //     this.expandedKeys = [...JSON.parse(savedExpandedNodes)];
    //   }
    //   // 恢复选中状态
    //   const savedSelectedNode = sessionStorage.getItem("shareSelectedNode");
    //   if (savedSelectedNode) {
    //     const selectedNode = JSON.parse(savedSelectedNode);

    //     this.$nextTick(() => {
    //       this.$refs.tree.setCurrentKey(selectedNode.id);
    //     });
    //     this.$emit("handleTreeClick", selectedNode);
    //   }
    // } else {
      // 如果没有保存的数据，则重新获取
      this.getAllDatas();
    // }
  },
  computed: {
    ...mapState({
      elements: (state) => state.elements,
    }),
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
  },
};
</script>
<style scoped>
.parkClass {
  display: inline-block;

  height: 15px;
  line-height: 15px;
  /*background-color:#278cd8;*/
  background: url(~@/assets/images/park.png) no-repeat left center;
  padding-left: 20px;
  /*font-weight: bold;*/
  color: #606266;
  font-size: 14px;
}
.areaClass {
  display: inline-block;
  line-height: 15px;
  height: 15px;
  /*background-color:#278cd8;*/
  background: url("~@/assets/images/area.png") no-repeat left center;
  padding-left: 20px;
}
.spaceClass {
  display: inline-block;
  width: 10px;
  height: 10px;
  /*background-color:#278cd8;*/
  background: url(~@/assets/images/space.png) no-repeat center center;
}
.el-tree {
  color: #5c5c5c !important;
  height: calc(100vh - 130px);
  overflow: auto;

  width: 100%;
}
.is-current {
  background: #afc0e9 !important;
}
.trees {
  border-right: 10px solid #eff2f7;
  padding: 10px 5px 0 5px;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
}
.el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
  background: #ccc !important;
}

.isActive {
  background: #ccc !important;
}
.search {
  border-radius: 10px !important;
  margin-bottom: 10px;
}
.tree-tip {
  font-size: 10px;
  color: red;
}

.add {
  color: #409eff;
}
.edit {
  color: #67c23a;
}
.delete {
  color: #f56c6c;
}
.group-name-tip {
  color: red;
  font-size: 10px;
}
</style>
<style>
.trees .search .el-input__inner {
  border-radius: 4px;
}
</style>